import { useState, useEffect, useCallback } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function useJobActions() {
  const { user } = useAuth();
  const [savedIds, setSavedIds] = useState([]);
  const [appliedIds, setAppliedIds] = useState([]);

  const refresh = useCallback(async () => {
    if (!user) return;
    try {
      const [s, a] = await Promise.all([api.get("/saved/ids"), api.get("/applications")]);
      setSavedIds(s.data);
      setAppliedIds(a.data.map((x) => x.job_id));
    } catch (e) { /* noop */ }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const toggleSave = async (job) => {
    try {
      const { data } = await api.post(`/saved/${job.id}`);
      setSavedIds((prev) => (data.saved ? [...prev, job.id] : prev.filter((id) => id !== job.id)));
      toast.success(data.saved ? "Job saved" : "Removed from saved");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    }
  };

  const apply = async (job, note) => {
    try {
      await api.post("/applications", { job_id: job.id, cover_note: note });
      setAppliedIds((prev) => [...prev, job.id]);
      toast.success(`Applied to ${job.title}`);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    }
  };

  return { savedIds, appliedIds, toggleSave, apply, refresh };
}
